import type { CloudFetchParams } from './types.js';

export function internalApiBase(cloudApiBaseUrl: string): string {
  return cloudApiBaseUrl.replace(/\/+$/, '');
}

export async function fetchInternalApiJson<T>(
  params: CloudFetchParams & {
    path: string;
    errorLabel: string;
    method?: 'GET' | 'POST';
    body?: unknown;
  },
): Promise<{ ok: true; data: T } | { ok: false; error: string }> {
  const token = params.getCloudAccessToken();
  if (!token) return { ok: false, error: 'Missing cloud access token.' };
  const url = `${internalApiBase(params.cloudApiBaseUrl)}${params.path}`;
  const method = params.method ?? 'GET';
  const res = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(params.body != null ? { 'Content-Type': 'application/json' } : {}),
    },
    ...(params.body != null ? { body: JSON.stringify(params.body) } : {}),
  });
  if (!res.ok) {
    const t = await res.text().catch(() => '');
    return { ok: false, error: `${params.errorLabel} (${res.status}): ${t.slice(0, 200)}` };
  }
  const data = (await res.json().catch(() => null)) as T | null;
  if (!data) return { ok: false, error: `Invalid ${params.errorLabel.toLowerCase()} response.` };
  return { ok: true, data };
}
